import { api } from './api';

// The Friday calls & meetings form (no sign-in: the token is the agent's own).
export const weeklyActivityApi = {
    show: (token) => api.get('/weekly-activity/' + encodeURIComponent(token)).then((res) => res.data),
    submit: (token, calls, meetings) =>
        api.put('/weekly-activity/' + encodeURIComponent(token), { calls, meetings }).then((res) => res.data),
};

// # of Calls / # of Meetings typed over on SUMMIT Buckets.
// totals: [{ agent_id, calls?, meetings? }] — a figure left out is not changed.
export const bucketActivityApi = {
    saveTotals: (totals) => api.put('/buckets/activity-totals', { totals }).then((res) => res.data),
};
